import React from 'react';
import { useTranslation } from 'react-i18next';
import Icon from './Icon';

/* Figma asset: ReviewButton - review CTA with star rating */
export default function ReviewButton({ title, rating = '', onClick, className = '' }) {
  const { t } = useTranslation();
  const resolvedTitle = title || t('common.vehicle_review_title_default');
  return (
    <button
      onClick={onClick}
      className={`w-full flex items-center justify-between border border-mono-200 rounded-lg h-14 px-4 hover:bg-mono-50 transition ${className}`}
    >
      <span className="text-[15px] sm:text-[17px] font-bold text-mono-900">{resolvedTitle}</span>
      <div className="flex items-center gap-1.5">
        <Icon name="star-filled" size={16} className="text-star" />
        <span className="text-base font-bold text-mono-900">{rating}</span>
        <Icon name="chevron-right" size={16} className="text-mono-400" />
      </div>
    </button>
  );
}
